import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as actions from '../../actions'

import Players from './Players'
import Teams from './Teams'
import Statistics from './Statistics'

class Administration extends Component {
  componentDidMount () {
    this.props.dispatch(actions.getAdminInitData())
  }

  render () {
    return (
      <main className='admin-view'>
        <div className='main-col'>
          <div><Teams /></div>
        </div>
        <div className='main-col main-col-admin'>
          <div style={{ padding: 0 }}><Players /></div>
        </div>
        <div className='main-col' style={{ marginRight: '15px' }}>
          <div style={{ paddingBottom: '20px' }}><Statistics /></div>
        </div>
      </main>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    pathname: state.routerReducer.location.pathname
  }
}

export default connect(mapStateToProps)(Administration)



// WEBPACK FOOTER //
// ./src/screens/administration/Administration.js